"use strict";
Object.defineProperty(exports, "__esModule", { value: true });
const baseStyle = {
    th: {
        fontFamily: 'body',
        fontWeight: 'semibold',
        textTransform: 'none',
        color: 'gray.800',
    },
    td: {
        fontFamily: 'body',
        fontWeight: 'normal',
    },
};
const variantSimple = {
    th: {
        borderColor: 'gray.800',
        backgroundColor: 'lilac.100',
        borderBottomColor: 'gray.300',
        _last: {
            borderLeftColor: 'gray.200',
            borderLeftWidth: '1px',
            textAlign: 'right',
        },
    },
    td: {
        borderBottomColor: 'gray.300',
        _last: {
            borderLeftColor: 'gray.200',
            borderLeftWidth: '1px',
            textAlign: 'right',
        },
    },
};
const sizes = {
    sm: {
        th: {
            px: '4',
            py: '1',
            fontSize: 'xs',
            height: '28px',
        },
        td: {
            px: '4',
            py: '1',
            fontSize: 'xs',
            height: '28px',
        },
    },
    md: {
        th: {
            px: '4',
            py: '2',
            fontSize: 'sm',
            height: '44px',
        },
        td: {
            px: '4',
            py: '2',
            fontSize: 'sm',
            height: '48px',
        },
    },
    lg: {
        th: {
            px: '8',
            py: '4',
            fontSize: 'md',
            height: '56px',
        },
        td: {
            px: '8',
            py: '4',
            fontSize: 'md',
            height: '64px',
        },
    },
};
const TableStyle = {
    variants: {
        simple: variantSimple,
    },
    sizes,
    baseStyle,
};
exports.default = TableStyle;
